import femaleUserImg from "@/female/assets/reviews/weight-loss-user.webp";
import maleUserImg from "@/male/assets/reviews/weight-loss-user.webp";

export const reviews = {
    female: {
        title: "We've helped tens of thousands of women transform their bodies",
        quote: "I can finally fit back into my favorite jeans! Thank you Zing Coach :)",
        name: "Teresa Watson",
        userImg: femaleUserImg,
    },
    male: {
        title: "We've helped tens of thousands of men transform their bodies",
        quote: "I can finally fit back into my favorite jeans! Thank you Zing Coach :)",
        name: "David Brown",
        userImg: maleUserImg,
    },
};
